export const iconFontAwesomeMapsVest = (
	<i className="fa-solid fa-vest"></i>
);
